import React from "react";

var BadgeIdIcon = function BadgeIdIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 3h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2zm12 2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM7.5 9c1.378 0 2.5 1.121 2.5 2.5 0 1.378-1.122 2.5-2.5 2.5S5 12.878 5 11.5C5 10.121 6.122 9 7.5 9zM11 19H4v-.756C4 16.455 5.57 15 7.5 15s3.5 1.455 3.5 3.244zm8-3h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm0-4h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1z"
  }));
};

BadgeIdIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
BadgeIdIcon.defaultProps.solid = true;
export default BadgeIdIcon;